export const coverMap = {
  tagId: 1,
  sizeId: 0,
  textStyleId: 0,
  type: 0,
  sizeName: "",
  size: { width: 291, height: 180 },
  bgParameter: {}, // 背景相关数据
  backgroundId: 0,
  elementTypeId: 2,
  elementId: 0,
  elementImg: "",
  isAiElement: false,
  elementInfo: {
    elementWidth: 480,
    elementHeight: 240,
    offsetX: 0,
    offsetY: 0,
    remainPart: 0,
  },
  textInfo: {
    textPositionX: "-1",
    textPositionY: "",
    textAlignType: 0,
  },
  fontStyles: [
    {
      textMinLength: 0,
      textMaxLength: 10,
      text: "",
      lineIndex: 0,
      isShowText: true,
      isMainTitle: false,
      labelName: "标签",
      labelStyleVisible: true,
    },
  ],
};
